import React, { Component } from 'react';
import { routes } from 'constants/config';
import request from 'utils/request_ajax';

class OpenDownload extends Component {
  state = {
    downloadUrl: null,
    requestUrl: null,
    isFetchingDownloadUrl: false,
  };

  componentDidMount() {
    if (this.props.answerId) {
      this.setState(
        {
          requestUrl: routes.ANSWER_UPLOAD_DOWNLOAD_URL_FOR_ANSWER_ID(
            this.props.answerId,
          ),
        },
        this.loadUrlAndTimer,
      );
    } else if (this.props.questionId) {
      this.setState(
        {
          requestUrl: routes.ANSWER_UPLOAD_DOWNLOAD_URL_FOR_QUESTION_ID(
            this.props.questionId,
          ),
        },
        this.loadUrlAndTimer,
      );
    }
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  loadUrlAndTimer = () => {
    this.getDownloadUrl();
    this.urlExpirationTimer();
  };

  // The Filestack URL expires 3 hours from issue time, so after 2.5 hours
  // we will ask for a fresh Filestack URL for the user
  urlExpirationTimer = () => {
    this.interval = setInterval(() => {
      this.getDownloadUrl();
    }, this.hoursToMilliseconds(2.5));
  };

  hoursToMilliseconds = hours => {
    return 1000 * 60 * 60 * hours;
  };

  getDownloadUrl = () => {
    this.setState({ isFetchingDownloadUrl: true });
    request
      .get(this.state.requestUrl)
      .then(data => {
        this.setState({
          downloadUrl: data.download_url,
          isFetchingDownloadUrl: false,
        });
      })
      .catch(error => {
        console.error(error);
        this.setState({ isFetchingDownloadUrl: false });
      });
  };

  throwErrorMessage = () => {
    const isGrader = window.location.href.includes('/grades');

    let message = '';

    if (isGrader) {
      message = t(
        'questions.question.upload_response.upload_file_error_grader',
      );
    } else if (this.props.finished) {
      message = t(
        'questions.question.upload_response.upload_file_error_unable_to_download',
      );
    } else {
      message = t(
        'questions.question.upload_response.upload_file_error_delete',
      );
    }

    // eslint-disable-next-line no-alert
    alert(message);
  };

  render() {
    return this.state.isFetchingDownloadUrl ? (
      <p>{this.props.fileName}</p>
    ) : (
      <a
        className="u-linkBtn c-p"
        href={this.state.downloadUrl}
        onClick={!this.state.downloadUrl ? this.throwErrorMessage : null}
        target="_blank"
        rel="noopener noreferrer"
      >
        {this.props.fileName}
      </a>
    );
  }
}

OpenDownload.defaultProps = {
  answerId: null,
  questionId: null,
  finished: false,
};

export default OpenDownload;
